<template>
    <span class="user_prfl_status">
        <!-- Group Avatar -->
        <template v-if="isGroup">
            <img v-if="image" :src="image" :alt="name">
            <img v-else src="@/assets/images/user_circle_avtar.png" alt="">
        </template>

        <!-- User Avatar -->
        <template v-else>
            <img v-if="image" :src="image" class="chat_user_photo" :alt="name">
            <img v-else src="@/assets/images/user_circle_avtar.png" alt="">

            <i class="online-status" :class="statusClass" :title="statusTitle"></i>
        </template>
    </span>
</template>

<script>
export default {
    name: 'UserAvatar',

    props: {
        image: {
            type: String,
            default: ''
        },

        isGroup: {
            type: Boolean,
            default: false
        },

        isOnline: {
            type: Boolean,
            default: false
        },

        currentStatus: {
            type: String,
            default: 'available'
        },

        name: {
            type: String,
            default: ''
        }
    },

    computed: {
        statusClass() {
            if (!this.isOnline) return '';

            switch ((this.currentStatus || '').toLowerCase()) {
                case 'available':
                    return 'available';

                case 'be right back':
                    return 'be_right_back';

                case 'lunch away':
                    return 'lunch_away';

                case 'busy':
                    return 'busy';

                case 'at a meeting':
                    return 'at_a_meeting';

                default:
                    return 'online';
            }
        },

        statusTitle() {
            if (!this.isOnline) {
                return '';
            }

            return this.currentStatus || 'Available';
        }
    }
}
</script>

<style lang="scss" scoped>
.user_prfl_status {
    width: 46px;
    border-radius: 50%;
    position: relative;
    margin-right: 10px;
    height: 46px;
    flex: 0 0 46px;
    background: linear-gradient(145deg, #334155, #0f172a);
    border: 2px solid rgba(255, 255, 255, 0.14);

    img {
        width: 100%;
        border-radius: 50%;
        height: 100%;
        object-fit: cover;
        object-position: top center;
    }

    .online-status {
        position: absolute;
        right: -1px;
        bottom: 0px;
        border: 1px solid #111827;
        border-radius: 50%;
        width: 11px;
        height: 11px;
        background: #9E9E9E;

        &.available {
            background-color: #38b124;
            box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.16);
        }

        &.be_right_back {
            background-color: #f3d32d;
            box-shadow: 0 0 0 2px rgba(243, 211, 45, 0.16);
        }

        &.lunch_away {
            background-color: #1483E5;
            box-shadow: 0 0 0 2px rgba(20, 131, 229, 0.16);
        }

        &.busy {
            background-color: #ee0809;
            box-shadow: 0 0 0 2px rgba(238, 8, 9, 0.16);
        }

        &.at_a_meeting {
            background-color: #f66c11;
            box-shadow: 0 0 0 2px rgba(246, 108, 17, 0.16);
        }

        &.online {
            background-color: #4CAF50;
            box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.16);
        }

        &.away {
            background-color: #f1c40f;
            box-shadow: 0 0 0 2px rgba(241, 196, 15, 0.16);
        }

        &.busy {
            background-color: #F44336;
            box-shadow: 0 0 0 2px rgba(244, 67, 54, 0.16);
        }
    }
}
</style>